<template>
  <div class="title-video-button" v-if="videoUrl && videoUrl!=='-'">
    <v-btn
      color="#EC5785"
      dark
      :outlined="outlined"
      small
      @click.native="onVideoTrigger"
      class="pa-3 mx-4 text-none"
    >
      <v-icon left>slideshow</v-icon>
      <span > {{videoText}} </span>
    </v-btn>
  </div>
</template>

<script lang="ts">
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import VideoTrigger from '@/components/Mixins/VideoTrigger.vue';

@Component
export default class TitleVideoButton extends Mixins(VideoTrigger) {
  @Prop({ type: [String], required: true })
  public videoKey!: string;

  @Prop({ type: [Boolean], default: () => true })
  public outlined!: boolean;

  private get videoText(): string {
    return this.$t('commons.video.see_tutorial').toString();
  }

  @Watch('videoKey', { immediate: true })
  private onVideoKeyChange() {
    if (this.localeVideoKey !== this.videoKey) {
      this.localeVideoKey = this.videoKey;
    }
  }
}
</script>
<style lang="stylus">
.title-video-button {
  display: inline-block;
}
</style>
